import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { getInitRecaptchaConfigProvider, ReCaptchaConfigArgs } from '@core/recaptcha/data-access';

@NgModule()
export class ReCaptchaModule {
  constructor(@Optional() @SkipSelf() parentModule: ReCaptchaModule) {
    if (parentModule) {
      throw new Error('ReCaptchaModule is already loaded. Import it in the AppModule only!');
    }
  }

  static forRoot(args: ReCaptchaConfigArgs = {}): ModuleWithProviders<ReCaptchaModule> {
    return {
      ngModule: ReCaptchaModule,
      providers: [getInitRecaptchaConfigProvider(args)],
    };
  }
}
